import './modules/filters';
import './modules/filter-disclosure';
import './modules/filter-complex';
import './polyfill';
import './modules/tabs';
import './modules/modal';
import './modules/product-nav';
import './modules/video';
import './modules/tracking';
import './modules/anchor-link';
import './modules/video-banner';
import './modules/icon-embed';
import './modules/turnstile';

import Animations from './animations';

import Nav from './modules/nav';
const nav = new Nav(document.querySelector('[data-js-nav]'));

import './modules/sticky';
import './modules/product-tables';

class App {
  constructor() {
    App.importElements();

    // If document already loaded, call init
    document.onreadystatechange = function () {
      if (document.readyState !== 'loading') {
        App.init();
      }
    };
  }

  static importElements() {
    App.importAll(require.context('./elements/', true, /\.js$/));
  }

  static importAll(r) {
    r.keys().forEach(r);
  }

  static init() {
    Animations.init();
    App.setScrollbarWidth();
  }

  static setScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    // Set scrollbar width CSS variable
    const root = document.documentElement;
    root.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
  }
}

new App();
